module.exports = __webpack_public_path__ + "static/media/emerite.9afb08be.png";